import React from 'react';
import { Segment, Form, Input, Grid, Image } from 'semantic-ui-react';
import { Button, Notification, STATUS_TYPES } from 'dyl-components';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import * as EmailValidator from 'email-validator';


import authActions from 'actions/auth/auth';

import './index.scss';

const ForgottenPassword = ({ onSendPasswordRecoveryLink, isEmailValid, onChange }) => (
    <Grid columns="equal" stackable reversed="mobile">
        <Grid.Column style={{ padding: 0 }}>
            <Image src="https://images.dyl.com/login/dyl_logo.svg" className='ForgottenPassword__Logo' fluid alt="DYL Logo"/>
            <Image src="https://images.dyl.com/login/dyl_password_reset.png" className='ForgottenPassword__Image' fluid alt="DYL Reset Password"/>
        </Grid.Column>
        <Grid.Column style={{padding: 0}}>
            <div className="ForgottenPasswordWrapper">
                <Segment className='ForgottenPassword'>
                    <h1 className="ForgottenPassword__header">Reset Password</h1>
                    <div className="ForgottenPassword__content">
                        <Form onSubmit={onSendPasswordRecoveryLink}>
                            <div className="ForgottenPassword__fields">
                                <h3 className="ForgottenPassword__fields-text">Enter the email address associated with your account</h3>
                                <Form.Field>
                                    <Input icon='fa-solid fa-envelope' iconPosition='left' placeholder='Email Address' onChange={onChange} name='email' fluid />
                                </Form.Field>
                            </div>
                            <div className="ForgottenPassword__Button">
                                <Button style={{width: '75%'}} disabled={!isEmailValid} type="submit" color='blue' fluid>Send Password Recovery Link</Button>
                            </div>
                        </Form>
                    </div>
                </Segment>
            </div>
        </Grid.Column>
    </Grid>
)

class ForgottenPasswordContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            form: {
                email: ''
            },
            isEmailValid: false,
            redirect: null
        }
    }

    onSendPasswordRecoveryLink(e) {
        this.props.onSendPasswordRecoveryLink(this.state.form.email)
            .then((response) => {
                Notification.alert("A password reset link was sent to your email address", STATUS_TYPES.SUCCESS, true);
                this.setState({ redirect: '/login' })
            })
    }

    onChange(e) {
        let form = { ...this.state.form };
        form[e.target.name] = e.target.value;
		this.setState({ form, isEmailValid: EmailValidator.validate(form.email) });
    }

    componentDidMount() {
    }

    render() {
        if (this.state.redirect) {
            return <Navigate to={this.state.redirect} />
        }
        return (
            <ForgottenPassword 
	    onSendPasswordRecoveryLink={this.onSendPasswordRecoveryLink.bind(this)}
	    isEmailValid={this.state.isEmailValid}
	    onChange={this.onChange.bind(this)}
	    />
        );
    }
}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        onSendPasswordRecoveryLink: (email) => {
            return dispatch(authActions.sendPasswordRecoveryLink({ email }))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgottenPasswordContainer);
